module.exports = __webpack_public_path__ + "media/logos/icon-dark-b207196e.svg";